import Fragment from "./fragment";
import FragmentSummary from "./fragment-summary";
import PatResultType from "../enums/pat-result-type";

export default class PatMissed extends Fragment {
    constructor() {
        super();
        this.result = PatResultType.MISSED.code;
    }

    summarize(summaryContext) {
        const message = "failed";
        return new FragmentSummary(message);
    }

    updateSummaryContext(summaryContext) {
        summaryContext.eopPrinted = true;
    }
}
